import styled, { css } from 'styled-components';
import Btn from 'dc/Button';
import { Typ30 } from 'dc/Typ';

export const Wrapper = styled.div`
  background-color: white;
  border-radius: 8px 8px 0 0;
`;

export const Button = styled(Btn)`
  padding: 12px;
  ${props =>
    props.active &&
    css`
      border-bottom: solid 2px #0099a9;
    `};
`;

type TextProps = {
  active: boolean;
};

export const Text = styled(Typ30)<TextProps>`
  color: ${props => (props.active ? '#0099A9' : '#546e7a')};
`;
